/* Miphoria PDP — gallery lead image, sticky add-to-cart, in-view video autoplay,
   scroll reveals and recommendation loading. Safe to include from several sections. */
(function () {
  if (window.__pdpAtelier) return;
  window.__pdpAtelier = true;

  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
  const desktop = window.matchMedia('(min-width: 750px)');

  /* Gallery: the first visible slide spans both columns on desktop.
     product-info.js shows/hides slides per colour via inline display. */
  function markLead() {
    document.querySelectorAll('.pdp .product__media-list').forEach((list) => {
      const items = Array.from(list.querySelectorAll('.product__media-item'));
      items.forEach((el) => el.classList.remove('pdp-lead'));
      const first = items.find((el) => el.style.display !== 'none' && getComputedStyle(el).display !== 'none');
      if (first) first.classList.add('pdp-lead');
    });
  }

  /* Sticky add-to-cart: the button is an .upsell-add-btn, so it opens the global
     select-variant popup (layout/theme.liquid) pre-set to the current variant. */
  function initSticky() {
    document.querySelectorAll('.pdp-sticky').forEach((bar) => {
      const sectionId = bar.dataset.section;
      const btn = bar.querySelector('.upsell-add-btn');
      const meta = bar.querySelector('[data-sticky-meta]');
      const img = bar.querySelector('.pdp-sticky__img');
      const mainBtn = () => document.getElementById(`ProductSubmitButton-${sectionId}`);
      const footer = document.querySelector('footer, .footer');
      let pastButton = false;
      let footerVisible = false;

      const sync = () => {
        const visible = pastButton && !footerVisible;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
        btn.tabIndex = visible ? 0 : -1;
        // Lift floating widgets (WhatsApp chat) above the bar while it is showing
        document.documentElement.classList.toggle('pdp-sticky-on', visible);
        document.documentElement.style.setProperty('--pdp-sticky-h', `${bar.offsetHeight}px`);
      };

      // Read positions on scroll (rAF-throttled) instead of observing the form: the buy buttons are
      // re-rendered after load / on variant change, and an observer would keep watching a detached node.
      let ticking = false;
      const measure = () => {
        ticking = false;
        const main = mainBtn();
        if (!main) return;
        const anchor = main.closest('.product-form__buttons') || main;
        // Treat the buttons as scrolled past once they slip under the sticky header
        const header = document.querySelector('sticky-header, .section-header');
        const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        pastButton = anchor.getBoundingClientRect().bottom < headerBottom;
        footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        sync();
      };
      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(measure);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      measure();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const v = data && data.variant;
          if (v && meta) {
            const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
            const price = new Intl.NumberFormat('en-IN', { style: 'currency', currency, maximumFractionDigits: 0 }).format(v.price / 100);
            meta.textContent = `${v.title} · ${price}`;
          }
          if (v) {
            btn.dataset.variantOptions = JSON.stringify(v.options);
            btn.dataset.price = v.price;
          }
          if (v && v.featured_image) {
            const src = v.featured_image.src;
            const sized = (w) => src + (src.includes('?') ? '&' : '?') + 'width=' + w;
            if (img) img.src = sized(120);
            btn.dataset.image = sized(600);
          }
          setTimeout(() => { sync(); markLead(); }, 120);
        });
      }
    });
  }

  /* Desktop: keep the info column's bottom in view while the gallery scrolls */
  function initInfoColumn() {
    const header = () => {
      const h = document.querySelector('.section-header .header-wrapper, sticky-header, .header-wrapper');
      return h ? Math.max(0, Math.min(h.getBoundingClientRect().bottom, 140)) : 0;
    };
    document.querySelectorAll('.pdp .product__info-container.product__column-sticky').forEach((col) => {
      const set = () => {
        const topGap = header() + 24;
        const fits = col.offsetHeight + topGap + 24 <= window.innerHeight;
        col.style.setProperty('--pdp-info-top', `${fits ? topGap : window.innerHeight - col.offsetHeight - 24}px`);
      };
      set();
      if ('ResizeObserver' in window) new ResizeObserver(set).observe(col);
      window.addEventListener('resize', set);
    });
  }

  /* Belt size table: highlight the row for the selected option value */
  function initSizeMap() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const v = data && data.variant;
      if (!v) return;
      document.querySelectorAll('[data-size-map]').forEach((map) => {
        const value = v.options[Number(map.dataset.optionIndex)];
        map.querySelectorAll('tr[data-value]').forEach((row) => row.classList.toggle('is-current', row.dataset.value === value));
      });
    });
  }

  /* Videos play only while on screen */
  function initVideos(root) {
    const vids = root.querySelectorAll('video[data-pdp-autoplay]');
    if (!vids.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          if (target.preload === 'none') target.preload = 'auto';
          const p = target.play();
          if (p && p.catch) p.catch(() => {});
        } else {
          target.pause();
        }
      });
    }, { threshold: 0.25 });
    vids.forEach((v) => io.observe(v));
  }

  function initReveal(root) {
    const els = root.querySelectorAll('[data-pdp-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* Recommendations replace the fallback collection when Shopify returns results */
  function initRecs() {
    document.querySelectorAll('[data-pdp-recs]').forEach((el) => {
      const url = el.dataset.url;
      if (!url) return;
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-pdp-recs]');
          if (!fresh || fresh.dataset.hasRecs !== 'true') return;
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
          el.querySelectorAll('[data-pdp-reveal]').forEach((n) => n.classList.add('is-in'));
        })
        .catch(() => {});
    });
  }

  ready(() => {
    markLead();
    initSticky();
    initInfoColumn();
    initSizeMap();
    initVideos(document);
    initReveal(document);
    initRecs();
    desktop.addEventListener && desktop.addEventListener('change', markLead);
    // Belt-and-braces: re-mark the lead slide after any option change, once product-info.js has filtered slides.
    document.addEventListener('change', (e) => {
      if (e.target.closest && e.target.closest('variant-selects')) setTimeout(markLead, 600);
    });
  });

  document.addEventListener('shopify:section:load', (e) => {
    markLead();
    initVideos(e.target);
    initReveal(e.target);
  });
})();
